<script>
export default Vue.extend({
  props: {
    dateRange: {
      type: Object,
      required: true
    }
  },
  computed: {
    minDate() {
      return this.$moment(this.dateRange.start.date).toDate();
    },
    maxDate() {
      return this.$moment(this.dateRange.end.date).toDate();
    }
  },
  methods: {
    open(entry) {
      window.open(`${entry.schedule.url}?entry=${entry.id}`, "_blank");
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/schedule/Load.vue